export default __webpack_public_path__ + "static/media/annex2.d7f7b793.png";